
import { useState, useEffect } from 'react';
import { OrderProduct } from '../../types/orderTypes';
import { useToast } from '@/components/ui/use-toast';

export const useProductManagement = () => {
  const [products, setProducts] = useState<OrderProduct[]>([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const { toast } = useToast();
  
  // Calculate total amount whenever products change
  useEffect(() => {
    const newTotal = products.reduce((sum, product) => {
      return sum + (product.price * product.quantity);
    }, 0);
    setTotalAmount(newTotal);
  }, [products]);
  
  const handleAddProduct = (product: OrderProduct) => {
    console.log("Adding product to order:", product);
    
    // Lors de l'édition d'une commande, nous utilisons l'ID unique de l'item au lieu du product_id
    // car un même produit peut apparaître plusieurs fois dans une commande avec des quantités différentes
    const existingProductIndex = products.findIndex(p => p.id === product.id);
    
    if (existingProductIndex !== -1) {
      // Si le produit existe déjà avec le même ID (lors de l'édition), nous mettons à jour ses propriétés
      const updatedProducts = [...products];
      updatedProducts[existingProductIndex] = { ...product };
      setProducts(updatedProducts);
      
      toast({
        title: "Produit mis à jour",
        description: `${product.name} a été mis à jour dans la commande`,
      });
    } else {
      // Si le produit n'existe pas encore, nous l'ajoutons
      setProducts(prevProducts => [...prevProducts, product]);
      
      toast({
        title: "Produit ajouté",
        description: `${product.name} a été ajouté à la commande`,
      });
    }
  };
  
  const handleRemoveProduct = (productId: string) => {
    setProducts(products.filter(product => product.id !== productId));
  };
  
  // Nouvelle fonction pour réinitialiser tous les produits (utilisée lors de l'édition)
  const resetProducts = () => {
    setProducts([]);
  };

  return {
    products,
    totalAmount,
    handleAddProduct,
    handleRemoveProduct,
    resetProducts
  };
};
